import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getDocumentMaintenanceHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "DocumentMaintenance", ...action.payload }),
		);
		yield put({
			type: types.GET_DOCUMENTMAINTENANCE_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_DOCUMENTMAINTENANCE_ERROR,
			payload,
		});
	}
}

export function* getDocumentMaintenanceWatcherSaga() {
	yield takeLatest(types.GET_DOCUMENTMAINTENANCE_START, getDocumentMaintenanceHandlerSaga);
}

//create

//delete

function* deleteDocumentMaintenanceHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("DocumentMaintenance", action.payload),
		);
		yield put({
			type: types.DELETE_DOCUMENTMAINTENANCE_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_DOCUMENTMAINTENANCE_ERROR,
			payload,
		});
	}
}

export function* deleteDocumentMaintenanceWatcherSaga() {
	yield takeLatest(
		types.DELETE_DOCUMENTMAINTENANCE_START,
		deleteDocumentMaintenanceHandlerSaga,
	);
}

//update
